var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotesFromFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 7 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M22 7H8c-.55 0-1 .508-1 1.07v10.978c0 .562.45.952 1 .952h1v2.376c0 .564.404.659.902.415L15.28 20H22c.55 0 1-.39 1-.952V8.07C23 7.508 22.55 7 22 7"
})));
export default SvgNotesFromFilled;